import { render, staticRenderFns } from "./ValueView.vue?vue&type=template&id=51fa1a68"
import script from "./ValueView.vue?vue&type=script&lang=js"
export * from "./ValueView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports